
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"52","height":"52","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"52","height":"52","rx":"26","fill":"#F1F0F9"}}),_c('path',{attrs:{"d":"M19.28 24.971c1.059 0 1.92-.922 1.92-2.057 0-1.134-.861-2.057-1.92-2.057s-1.92.923-1.92 2.057c0 1.135.861 2.057 1.92 2.057zm13.44 0c1.059 0 1.92-.922 1.92-2.057 0-1.134-.861-2.057-1.92-2.057s-1.92.923-1.92 2.057c0 1.135.861 2.057 1.92 2.057zM33.68 26h-1.92c-.528 0-1.005.228-1.353.598 1.209.71 2.067 1.993 2.253 3.516h1.98c.531 0 .96-.46.96-1.028v-1.029c0-1.134-.861-2.057-1.92-2.057zM26 26c1.857 0 3.36-1.61 3.36-3.6s-1.503-3.6-3.36-3.6-3.36 1.61-3.36 3.6S24.143 26 26 26zm2.304 1.029h-.249a4.47 4.47 0 01-2.055.514 4.479 4.479 0 01-2.055-.514h-.249c-1.908 0-3.456 1.658-3.456 3.702v.926c0 .852.645 1.543 1.44 1.543h8.64c.795 0 1.44-.691 1.44-1.543v-.926c0-2.044-1.548-3.702-3.456-3.702zm-6.711-.431A1.852 1.852 0 0020.24 26h-1.92c-1.059 0-1.92.922-1.92 2.057v1.029c0 .569.429 1.028.96 1.028h1.977c.189-1.523 1.047-2.806 2.256-3.516z","fill":"#7F58F0"}})])
          )
        }
      }
    